import request from '@/assets/js/request';

export function getDetail(params) {
  return request({
    url: '/detail',
    method: 'post',
    data: params,
  });
}

// export function openUrl(app_id, c2a_cid) {
//   return request({
//     url: `/v1/app/open?app_id=${app_id}&c2a_cid=${c2a_cid}`,
//     method: 'get',
//   });
// }

export function addInstall(params) {
  return request({
    url: '/install',
    method: 'post',
    data: params,
  });
}

export function InitWebpush(params) {
  return request({
    url: '/init',
    method: 'post',
    data: params,
  });
}
